import { Image } from './types'

export const SMALL_MOBILE_IMAGE_RESIZE_WIDTH = 320
export const MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH = 480
export const LARGE_MOBILE_IMAGE_RESIZE_WIDTH = 640
export const DESKTOP_IMAGE_RESIZE_WIDTH = 1024
export const WIDE_SCREEN_IMAGE_RESIZE_WIDTH = 1600
export const STICKY_FOOTER_SCROLL_THRESHOLD = 100

export const isVideo = (image: Image): boolean => {
    return image?.src?.includes('.m3u8') ?? false
}

export const getImageUrl = (format: string, image: Image) => {
    const { src, thumbnail } = image || {}
    const _getResizedImageUrl = (width: number) => getResizedImageUrl(isVideo(image) ? thumbnail : src, width)
    switch (format) {
        case 'small-mobile':
            return _getResizedImageUrl(SMALL_MOBILE_IMAGE_RESIZE_WIDTH)
        case 'medium-mobile':
            return _getResizedImageUrl(MEDIUM_MOBILE_IMAGE_RESIZE_WIDTH)
        case 'large-mobile':
            return _getResizedImageUrl(LARGE_MOBILE_IMAGE_RESIZE_WIDTH)
        case 'desktop':
            return _getResizedImageUrl(DESKTOP_IMAGE_RESIZE_WIDTH)
        default:
            return _getResizedImageUrl(WIDE_SCREEN_IMAGE_RESIZE_WIDTH)
    }
}

export const getResizedImageUrl = (imageUrl: string | undefined, width: number) => {
    if (!imageUrl) {
        return null
    }
    const url = new URL(imageUrl)
    url.searchParams.set('imwidth', width.toString())
    return url.toString()
}
